"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageKey = void 0;
var StorageKey;
(function (StorageKey) {
    StorageKey["SETTINGS_CALENDAR_SHOW_WEEKENDS"] = "SETTINGS_CALENDAR_SHOW_WEEKENDS";
    StorageKey["SERVER_TYPE"] = "SERVER_TYPE";
    StorageKey["SERVER_ENVIRONMENT"] = "SERVER_ENVIRONMENT";
    StorageKey["SERVER_SALESFORCE_INSTANCE_URL"] = "SERVER_SALESFORCE_INSTANCE_URL";
    StorageKey["SERVER_SALESFORCE_ACCESS_TOKEN"] = "SERVER_SALESFORCE_ACCESS_TOKEN";
    StorageKey["SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION"] = "SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION";
    StorageKey["SERVER_SALESFORCE_REFRESH_TOKEN"] = "SERVER_SALESFORCE_REFRESH_TOKEN";
    StorageKey["SERVER_SALESFORCE_REFRESH_TOKEN_EXPIRATION"] = "SERVER_SALESFORCE_REFRESH_TOKEN_EXPIRATION";
    StorageKey["SCHEDULER_WORKSPACE_ID"] = "SCHEDULER_WORKSPACE_ID";
    StorageKey["USER_CONTEXT"] = "USER_CONTEXT";
    StorageKey["SUBJECT"] = "SUBJECT";
    StorageKey["RECIPIENTS_EMAILS"] = "RECIPIENTS_EMAILS";
    StorageKey["COMPOSE_VIEW_ID"] = "COMPOSE_VIEW_ID";
    StorageKey["INTEGRATION"] = "INTEGRATION";
    StorageKey["DEFAULT_TEMPLATE_ID"] = "DEFAULT_TEMPLATE_ID";
    StorageKey["DEFAULT_HOST"] = "DEFAULT_HOST";
    StorageKey["SERVER_PREFIX"] = "SERVER_PREFIX";
    StorageKey["SETTINGS_SHOW_GUIDE"] = "SETTINGS_SHOW_GUIDE";
    StorageKey["CONNECT_GOOGLE_CONTACTS_BANNER_DISMISSED"] = "CONNECT_GOOGLE_CONTACTS_BANNER_DISMISSED";
})(StorageKey = exports.StorageKey || (exports.StorageKey = {}));
